import clsx from 'clsx';
import { useCallback } from 'react';
import { Calendar, X } from 'lucide-react';
import WojtekmajDateTimeRangePicker from '@wojtekmaj/react-datetimerange-picker';

import '@wojtekmaj/react-datetimerange-picker/dist/DateTimeRangePicker.css';
import 'react-calendar/dist/Calendar.css';

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

function noop() {}

export function DateTimeRangePicker({
  className,
  minDate,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}: {
  className?: string;
  minDate?: Date;
  startDate?: Date;
  endDate?: Date;
  onStartDateChange?: (date?: Date) => void;
  onEndDateChange?: (date?: Date) => void;
}) {
  const onDateChange = useCallback(
    (date: Value) => {
      const setStart = onStartDateChange ?? noop;
      const setEnd = onEndDateChange ?? noop;

      if (Array.isArray(date)) {
        if (date[0] && date[1]) {
          setStart(date[0]);
          setEnd(date[1]);
        }
      } else if (!date) {
        setStart(undefined);
        setEnd(undefined);
      } else {
        setStart(date);
        setEnd(undefined);
      }
    },
    [onEndDateChange, onStartDateChange]
  );

  return (
    <WojtekmajDateTimeRangePicker
      className={clsx('form-control w-auto [&>div]:border-0', className)}
      disableClock
      maxDetail="second"
      minDate={minDate}
      onChange={onDateChange}
      value={[startDate ?? minDate ?? null, endDate ?? null]}
      calendarIcon={<Calendar />}
      clearIcon={<X />}
      format="y/MM/dd hh:mm:ss a"
    />
  );
}
